module.exports = __webpack_public_path__ + "static/media/alexsandra.a504e095.jpeg";